/** Reading a job description the API returned: the same wording as the company front. */

export const getTemplateTitle = (template) =>
  template?.name || template?.title || '';

export const getTemplateQualification = (template) =>
  template?.qualification || template?.title || '';

// "Le Marin, Martinique": only a populated address carries a city.
export const formatTemplateCity = (location) => {
  if (!location || typeof location !== 'object') return '';
  return [location.city, location.department]
    .map((part) => (typeof part === 'string' ? part.trim() : ''))
    .filter(Boolean)
    .join(', ');
};

export const formatTemplateAddress = (location) => {
  if (!location) return '';
  if (typeof location === 'string') return location;
  const { street, postcode, city, department } = location;
  return [street, postcode, city, department].filter(Boolean).join(' ');
};

const hourlyRateFormatter = new Intl.NumberFormat('fr-FR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatTemplateRate = (template) => {
  const wage = template?.salary?.wage_per_hour;
  return typeof wage === 'number' && Number.isFinite(wage)
    ? `${hourlyRateFormatter.format(wage)}€`
    : '';
};

export const formatTemplateList = (list) =>
  Array.isArray(list) && list.length > 0 ? list.join(', ') : '';

const PROVIDER_LABELS = {
  company: 'Entreprise',
  temp_worker: 'Intérimaire',
};

export const formatTemplateTools = (tools) =>
  Array.isArray(tools)
    ? tools
        .map((tool) =>
          typeof tool === 'string'
            ? tool
            : `${tool?.name}${
                PROVIDER_LABELS[tool?.providedBy]
                  ? ` (${PROVIDER_LABELS[tool.providedBy]})`
                  : ''
              }`
        )
        .filter(Boolean)
        .join(', ')
    : '';

// Missions only know tool names, whoever provides them.
export const toToolNames = (tools) =>
  Array.isArray(tools)
    ? tools
        .map((tool) => (typeof tool === 'string' ? tool : tool?.name))
        .filter((name) => typeof name === 'string' && name.trim() !== '')
        .map((name) => name.trim())
    : [];

export const formatTemplateContact = (template) =>
  [template?.contact?.name, template?.contact?.poste].filter(Boolean).join(' - ');

// Search on what the card shows, accents and case aside.
const searchable = (value) =>
  typeof value === 'string'
    ? value
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
    : '';

export const filterTemplates = (templates, query) => {
  const words = searchable(query).split(/\s+/).filter(Boolean);
  const list = Array.isArray(templates) ? templates : [];
  if (words.length === 0) return list;
  return list.filter((template) => {
    const text = searchable(
      [
        getTemplateTitle(template),
        getTemplateQualification(template),
        formatTemplateCity(template?.location),
      ].join(' ')
    );
    return words.every((word) => text.includes(word));
  });
};
